module.exports = __webpack_public_path__ + "img/PeepsHooray.05da7c5f.svg";